export default __webpack_public_path__ + "static/media/m_session8_44.02deb0a6.png";